const MOUVEMENT_CLIENT_PIECE = {
  type: {
    autre: 'Autre',
    facture: 'Facture',
    avoir: 'Avoir',
    acompte: 'Acompte',
    reglement: 'Règlement',
    escompte: 'Escompte',
    gestionCourante: 'Gestion courante',
    charge: 'Charge',
    paiement: 'Paiement',
    avoirDeCharge: 'Avoir de charge',
    od: 'Od',
  },
};

export default MOUVEMENT_CLIENT_PIECE;
